import React from 'react';
import LoadingSpinner from "./LoadingSpinner";
import axios from "axios";
import {BASE_URL} from "./Constants";

class Regulatory extends React.Component {

    state = {
        isLoading: true,
        content: null
    }

    componentDidMount() {
        this.loadContent();
    }

    loadContent() {
        axios.get(BASE_URL + "/regulations/de")
            .then(result => {
                const content = result.data.data;

                this.setState({ content, isLoading: false });
            })
    }

    LoadingView() {
        return (
            <LoadingSpinner title="Laden..."/>
        );
    }

    ImprintView() {
        return (
            <div>
                <p className="heading-small" id="leading">Reise</p>
                <p className="bodyText" id="leading">
                    { this.state.content.travel }
                </p>

                <div className="divider" />

                <p className="heading-small" id="leading">Zoll</p>
                <p className="bodyText" id="leading">
                    { this.state.content.customs }
                </p>
            </div>
        );
    }

    render() {
        return (
            <div className="wrapper">
                <div className="titlebar">
                    <p className="titlebar-title">Reise- und Zollbestimmungen</p>
                </div>

                <div className="content">
                    {
                        this.state.isLoading ? this.LoadingView() : this.state.content != null ? this.ImprintView() : null
                    }
                </div>
            </div>
        );
    }
}

export default Regulatory;
